<template>
  <div class="terms-of-use">
    <h1 class="seo-title">Пользовательское соглашение</h1>
    <div class="wrapper">
      <Navigation />
      <div class="terms-of-use__main">
        <p class="terms-of-use__main__title">{{ $t('general.terms') }}</p>
        <div class="terms-of-use__main__text">
          <!--          <img v-if="isCountryRu($store.state.ipCountry)" class="terms-of-use__img" src="../../assets/images/footer/address.svg" alt="address">-->
          <div class="terms-of-use__main__text__t">
            <div class="terms-of-use__main__text__t__company" v-if="!isCountryFromRu($store.state.ipCountry)"></div>
            <p v-for="item in $t('terms')" :key="item" v-html="item"></p>
          </div>
        </div>
      </div>
    </div>
    <!--    <Footer />-->
  </div>
</template>

<script>
import Navigation from '@/components/Navigation/Navigation'

import ipUtil from '@/utils/ip'

export default {
  name: 'TermsOfUse',
  components: {
    Navigation
  },
  methods: {
    isCountryFromRu(c) {
      return ipUtil.isCountryInRuRegion(c)
    },
    isCountryRu(c) {
      return ipUtil.isCountryRu(c)
    }
  }
}
</script>

<style lang="scss">
@import './termsofuse.scss';
</style>
